import { Map, List } from 'immutable';
import { myRemoveEntities, myRemoveEntitiesBySport } from './utils';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_UPDATE, LIVE_MATCH_INIT, TIMETABLE_INIT, TIMETABLE_UPDATE } from '../../sagas/actions';
import * as PopularActions from '../../actions/popular';
import * as LineActions from '../../actions/lines';
import * as LiveActions from '../../actions/live';
import * as MatchResultsAction from '../../actions/matchResults';
export default function leaguesReducer(leagues, action) {
    switch (action.type) {
        case PopularActions.CLEAR_POPULAR:
        case LineActions.CLEAR_LINE:
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
        case MatchResultsAction.FETCH_MATCH_RESULTS:
        case MatchResultsAction.CLEAR_MATCH_RESULTS:
            return Map();
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_FULL_LINE:
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
        case MatchResultsAction.SUCCESS_FETCH_MATCH_RESULTS:
            return init(Map(), action.data);
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            return update(leagues, action.data);
        default:
            return leagues;
    }
}
function init(leagues, data) {
    if (data.leagues !== undefined) {
        leagues = addLeagues(leagues, data.leagues.add);
    }
    if (data.events !== undefined) {
        leagues = addLeagueMatches(leagues, data.events.add);
    }
    return leagues;
}
function update(leagues, data) {
    if (data.sports !== undefined && data.sports.remove !== undefined) {
        leagues = myRemoveEntitiesBySport(leagues, 'sportId', data.sports.remove);
    }
    if (data.leagues !== undefined) {
        leagues = myRemoveEntities(leagues, 'id', data.leagues.remove);
        leagues = addLeagues(leagues, data.leagues.add);
        leagues = changeLeagues(leagues, data.leagues.change);
    }
    if (data.events !== undefined) {
        leagues = myRemoveLeagueMatches(leagues, data.events.remove);
        leagues = addLeagueMatches(leagues, data.events.add);
    }
    return leagues;
}
function addLeagues(leagues, addedLeagues) {
    if (addedLeagues === undefined) {
        return leagues;
    }
    return leagues.withMutations(function (l) {
        for (var i = 0; i < addedLeagues.length; i++) {
            var league = new Map(addedLeagues[i]);
            league = league.set('matches', new List());
            l.set(league.get('id'), league);
        }
    });
}
function changeLeagues(leagues, changedLeagues) {
    if (changedLeagues === undefined) {
        return leagues;
    }
    var _loop_1 = function (i) {
        var league = changedLeagues[i];
        leagues = leagues.updateIn([league.id, 'name'], function () { return league.name; });
        leagues = leagues.updateIn([league.id, 'priority'], function () { return league.priority; });
    };
    for (var i = 0; i < changedLeagues.length; i++) {
        _loop_1(i);
    }
    return leagues;
}
function addLeagueMatches(leagues, addMatches) {
    if (addMatches === undefined) {
        return leagues;
    }
    for (var i = 0; i < addMatches.length; i++) {
        (function (leagueId, matchId) {
            leagues = leagues.updateIn([leagueId, 'matches'], function (m) { return m.push(matchId); });
        })(addMatches[i].leagueId, addMatches[i].id);
    }
    return leagues;
}
function myRemoveLeagueMatches(leagues, removeMatches) {
    if (removeMatches === undefined) {
        return leagues;
    }
    var _loop_2 = function (i) {
        var matchId = removeMatches[i].id;
        var leagueId = removeMatches[i].leagueId;
        var matches = leagues.getIn([leagueId, 'matches']);
        if (matches !== undefined) {
            matches = matches.filter(function (mId) { return (mId != matchId); });
        }
        leagues = leagues.setIn([leagueId, 'matches'], matches);
    };
    for (var i = 0; i < removeMatches.length; i++) {
        _loop_2(i);
    }
    return leagues;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/leaguesReducer.js